import { ButtonLink } from '../components/Button';
import { Blob } from '../components/Decorations';
import { Reveal } from '../components/Reveal';
import { site } from '../content/site';

export function ClosingCta() {
  return (
    <section className="px-5 py-20 sm:px-8">
      <div className="relative mx-auto max-w-5xl overflow-hidden rounded-blob bg-mint-700 px-8 py-16 text-center shadow-lift sm:px-14">
        <Blob
          className="pointer-events-none absolute -top-24 -right-16 h-72 w-72 text-mint-600/50"
          drift
        />
        <div className="relative">
          <Reveal>
            <h2 className="text-3xl text-white sm:text-4xl">
              Let&apos;s start a dialog.
            </h2>
          </Reveal>
          <Reveal delay={90}>
            <p className="mx-auto mt-4 max-w-xl leading-relaxed text-mint-50">
              Tell me a little about your family and what you need. I read every message myself,
              and I don&apos;t store or sell your information.
            </p>
          </Reveal>
          <Reveal delay={180}>
            <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
              <ButtonLink to="/contact" variant="blush">
                Get in touch
              </ButtonLink>
              <a
                href={`mailto:${site.email}`}
                className="font-display font-semibold text-mint-50 underline decoration-mint-400 decoration-2 underline-offset-4 transition-colors hover:text-white"
              >
                or email me directly
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
